import { c as _c } from "react/compiler-runtime";
import type { InputHTMLAttributes, ReactNode } from 'react';
import { IconRecurring } from './icon-recurring';
import { RadioCard } from './radio-card';
import { RadioCardGroup } from './radio-card-group';
type SetUpAutoshipOptionsProps = Readonly<{
  subscriptionType?: 'new' | 'existing';
  immediateTitle: ReactNode;
  nextOrderLabel: string;
  isImmediateDisabled: boolean;
  inputProps: Omit<InputHTMLAttributes<HTMLInputElement>, 'type' | 'id' | 'value' | 'checked' | 'disabled'>;
}>;
export const SetUpAutoshipOptions = t0 => {
  const $ = _c(16);
  const {
    subscriptionType,
    immediateTitle,
    nextOrderLabel,
    isImmediateDisabled,
    inputProps
  } = t0;
  const t1 = subscriptionType === "new";
  let t2;
  if ($[0] !== inputProps || $[1] !== isImmediateDisabled) {
    t2 = {
      ...inputProps,
      disabled: isImmediateDisabled
    };
    $[0] = inputProps;
    $[1] = isImmediateDisabled;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== immediateTitle || $[4] !== isImmediateDisabled || $[5] !== t1 || $[6] !== t2) {
    t3 = <RadioCard value="new" checked={t1} title={immediateTitle} disabled={isImmediateDisabled} inputProps={t2} />;
    $[3] = immediateTitle;
    $[4] = isImmediateDisabled;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const t4 = subscriptionType === "existing";
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <IconRecurring />;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== inputProps || $[10] !== nextOrderLabel || $[11] !== t4) {
    t6 = <RadioCard value="existing" checked={t4} iconSlot={t5} title={nextOrderLabel} inputProps={inputProps} />;
    $[9] = inputProps;
    $[10] = nextOrderLabel;
    $[11] = t4;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t3 || $[14] !== t6) {
    t7 = <RadioCardGroup>{t3}{t6}</RadioCardGroup>;
    $[13] = t3;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
};